module.exports = __webpack_public_path__ + "img/Staffel.c328d2a8.svg";